export default __webpack_public_path__ + "static/media/folder-music.82418d82.svg";